module.exports = __webpack_public_path__ + "assets/img/test_swirls_01_wALPHA_10.4fc00f99.png";